/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react'
import { getApiUrl } from '../../../../api/api'
import Loading from '../../../../component/Loading/Loading'
import {
  getFromlocalstorage,
  getFromsessionstorage
} from '../../../../component/MaHoaDuLieu/MaHoaDuLieu'
import Notify from '../../../../component/Notify/Notify'

const gameData = [{ name: 'TC', img: '/xoso/logotc.png', GpId: 1012 }]

const XoSo = () => {
  const [activeTab, setActiveTab] = useState('TC')
  const [datagame, setdatagame] = useState(null)
  const [isLoading, setisLoading] = useState(false)
  const dangnhap = localStorage.getItem('dangnhap')
  const [notiMessage, setNotiMessage] = useState('')

  const device = window.innerWidth > 540 ? 'd' : 'm'
  const userdata =
    JSON.parse(getFromsessionstorage('data_u')) ||
    JSON.parse(getFromlocalstorage('data_u'))

  useEffect(() => {
    handelgame(gameData[0].GpId)
  }, [])

  const handelgame = async GpId => {
    try {
      setisLoading(true)
      const response = await fetch(`${getApiUrl('backend')}/postdanhsachgame`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          GpId
        })
      })
      if (response.ok) {
        const data = await response.json()
        setdatagame(data.seamlessGameProviderGames)
        setisLoading(false)
      }
    } catch (error) {
      setisLoading(false)
      console.error(error)
    }
  }

  const hanldePostWidthdraw = async (gameProviderId, gameId) => {
    try {
      setisLoading(true)
      const response = await fetch(`${getApiUrl('backend')}/launch_game`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          portfolio: 'SeamlessGame',
          device,
          gameProviderId,
          gameId,
          userData: userdata,
          productId: null
        })
      })
      const data = await response.json()
      console.log(data)

      if (data.message) {
        setisLoading(false)
        alert(data.message)
      } else {
        if (data.url) {
          window.location.href = data.url
          setisLoading(false)
        }
      }
    } catch (error) {
      setisLoading(false)
      console.error('Failed to fetch API: ', error)
    }
  }

  return (
    <>
      {notiMessage && (
        <Notify
          message={notiMessage}
          setcontent={setNotiMessage}
          type='error'
        />
      )}

      <div className='dz-box'>
        <Loading isLoading={isLoading} />
        <div className='container wrapdz'>
          <div className='tab tab-box tab-row'>
            <div className='tab_ctrl'>
              {gameData.map((item, index) => (
                <button
                  key={index}
                  className={`tab_btn ${
                    activeTab === item.name ? 'active' : ''
                  }`}
                  onClick={() => {
                    handelgame(item.GpId)
                    setActiveTab(item.name)
                  }}
                >
                  <img src={`${item.img}`} alt={item.name} />
                  <span>{item.name}</span>
                </button>
              ))}
            </div>

            <div className='tab_main'>
              <div className='tab_item game-box' style={{ display: 'flex' }}>
                {datagame?.map((item, index) => (
                  <div className='gamebox-dz' key={index}>
                    <a>
                      <div className='hover-cover'>
                        <div className='logo'>
                          <img
                            src={item.gameInfos[0].gameIconUrl}
                            alt={item.gameInfos[0].gameName}
                          />
                        </div>
                        <p
                          className='play-btn'
                          onClick={() => {
                            if (!dangnhap) {
                              setNotiMessage('Vui lòng đăng nhập để chơi game')
                            } else {
                              hanldePostWidthdraw(
                                item.gameProviderId,
                                item.gameID
                              )
                            }
                          }}
                        >
                          Vào trò chơi
                        </p>
                      </div>
                      <p className='name'>{item.gameInfos[0].gameName}</p>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default XoSo
